
import React from "react";
import "./Luxury_Features.css";
import Common_Title from "../../common_components/common_title/Common_Title";
import { useNavigate } from "react-router-dom";

function LuxerySection() {
  const luxerys = [
    {
      img: "/assets/images/hospitality/certiguard.png",
      title: "Certiguard",
      text:
        "Silver-based Antimicrobial that reduces the growth of unwanted microbes in the mattress & gives safe, clean, and healthy sleep.",
        link:"/certiguard"
    },
    {
      img: "/assets/images/hospitality/gurenteed.png",
      title: "Peace of Mind Guaranteed",
      text:
        "Our dedicated customer care team takes pride in their work and focus on always providing the best service & support.",
        link:"/peace-of-mind"
    },
    {
      img: "/assets/images/hospitality/artho.png",
      title: "Aero Sleep Technology",
      text:
        "All products come with integrated temperature regulating properties, which provide ample ventilation throughout the mattresses.",
        link:"/aero-sleep-technology"

    },
  ];

  const navigate = useNavigate()

  return (
    <section className="luxery-section">
      <div className="container">

      <div className="title_with_line">
           <Common_Title title="Luxury Features" />
      </div>

      

        <div className="luxery-row row">
          {luxerys.map((item, index) => (
            <div className="luxery-col  col-lg-4 col-sm-6 col-md-6" key={index}>
              <div className="luxery-card">
                <div className="luxery-icon">
                  <img src={item.img} alt={item.title} className="luxery-img" />
                </div>

                <p className="luxery-subtitle">{item.title}</p>
                <p className="luxery-text">{item.text}</p>
              </div>
              <button className="luxery-read-btn" onClick={() => {navigate(item?.link)}}>READ MORE</button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default LuxerySection;
